export const footerLinks = [
    {
        name: "Company",
        children: [
            {
                name: "Mind",
                href: "/mind",
            },
            {
                name: "Lab",
                href: "/lab",
            },
            { name: "About Us", href: "/about-us" },
            { name: "Our Team", href: "/our-team" },

            // {
            //     name: "Keelmind.com",
            //     href: "https://keelmind.com",
            //     target: "_blank",
            // },
        ],
    },
    {
        name: "Legal",
        children: [
            { name: "Privacy Policy", href: "/mind/privacy-policy" },
            {
                name: "Terms of Use",
                href: "/mind/terms-of-use",
            },
            {
                name: "Terms & Conditions",
                href: "/mind/terms-and-conditions",
            },
        ],
    },
    {
        name: "Support",
        children: [
            { name: "Platform Support", href: "/mind/support-directory" },
            { name: "Security", href: "/mind/security" },
            { name: "FAQs", href: "/mind/faq" },
        ],
    },
    // {
    //     name: "Contact us",
    //     children: [
    //         { name: "admin@keel.digital", href: "mailto:admin@keel.digital" },
    //     ],
    // },
];

export const supportDirectoryLinks = [
    { text: "Crisis Support", href: "/crisis-support" },
    {
        text: "Technical Support",
        href: "https://geta-head.zendesk.com/hc/en-us",
        target: "_blank",
        rel: "noreferrer",
    },
    {
        text: "Supported Browser & System Requirements",
        href: "https://geta-head.zendesk.com/hc/en-us/articles/8217573426189",
        target: "_blank",
        rel: "noreferrer",
    },
];

export const megaMenu = [
    {
        navName: "Mind",
        title: "Keel Mind",
        text: "Discover how Keel Mind is reshaping mental health care through innovation, training, and connection.",
        hideOnMind: true,
        children: [
            {
                iconSrc: "who-we-are-mind.svg",
                name: "Who we are",
                href: "/mind",
                text: "Driving innovation in mental health technology.",
            },
            {
                iconSrc: "our-approach.svg",
                name: "Our approach",
                href: "/mind#our-approach",
                text: "Delivering scalable, evidence-based mental health solutions.",
            },
            {
                iconSrc: "our-tools.svg",
                name: "Our tools",
                href: "/mind#our-tools",
                text: "AI-powered systems supporting effective care delivery.",
            },
            {
                iconSrc: "our-features.svg",
                name: "Our features",
                href: "/mind#our-features",
                text: "Comprehensive tools built for performance and compliance.",
            },
            {
                iconSrc: "our-evidence.svg",
                name: "Our evidence",
                href: "/mind#our-evidence",
                text: "Validated outcomes through data and measurable results.",
            },
            {
                iconSrc: "our-impact.svg",
                name: "Our impact",
                href: "/mind#our-impact",
                text: "Improving access and efficiency across mental health sectors.",
            },
        ],
    },
    {
        navName: "Lab",
        title: "Keel Lab",
        text: "Keel Laboratory Services provides hormone-based diagnostics and data analytics that empower healthcare providers to deliver more personalized, evidence-informed mental health care.",
        hideOnMind: true,
        children: [
            {
                iconSrc: "who-we-are-lab.svg",
                name: "Who we are",
                href: "/lab",
                text: "Canada's only provincially licensed and ISO 15189 accredited lab for hormone testing.",
            },
            {
                iconSrc: "what-we-do-lab.svg",
                name: "What we do",
                href: "/lab#what-we-do",
                text: "Optimizing mental healthcare through advanced endocrinology testing and analysis.",
            },
            {
                iconSrc: "who-we-work-with.svg",
                name: "Who we work with",
                href: "/lab#who-we-work-with",
                text: "Partnering with leading laboratories to advance accessible, data-driven healthcare.",
            },
        ],
    },
    {
        navName: "Organizations",
        title: "Organizations",
        text: "Keel Mind's tailored organizational programs deliver secure, scalable peer support, training, and tools designed for specific institutional needs.",
        children: [
            {
                iconSrc: "first-responder-peer-support.svg",
                name: "First responder peer support",
                text: "A trusted digital platform designed to enhance peer connection, training, and wellness for first responders.",
                href: "https://peersupport.keelmind.com/",
                newTab: true,
            },
        ],
    },
    {
        navName: "About Us",
        title: "About Us",
        text: "Keel Digital Solutions unites clinical science and AI to empower organizations, researchers, and care providers with secure, evidence-based tools that improve mental health outcomes.",
        children: [
            {
                iconSrc: "how-keel-delivers.svg",
                name: "How Keel delivers",
                text: "Bridging emotional insight and biological data through AI and biomarkers.",
                href: "/about-us",
            },
            {
                iconSrc: "company-history.svg",
                name: "Company history",
                text: "From lab innovation to digital mental health leadership since 2021.",
                href: "/about-us#company-history",
            },
            {
                iconSrc: "what-we-value.svg",
                name: "What we value",
                text: "Guided by science, collaboration, and a commitment to client success.",
                href: "/about-us#what-we-value",
            },
        ],
    },
    {
        navName: "Our Team",
        title: "Our Team",
        text: "Keel Digital Solutions is led by industry professionals spanning healthcare, science, and technology, working together to advance mental health innovation through research, compliance, and collaboration.",
        children: [
            {
                iconSrc: "leadership-team.svg",
                name: "Leadership team",
                text: "A multidisciplinary team uniting expertise in technology, banking, sports, and healthcare.",
                href: "/our-team",
            },
            {
                iconSrc: "board-of-directors.svg",
                name: "Board of directors",
                text: "Experienced leaders providing governance and strategic direction for Keel Digital Solutions.",
                href: "/our-team#board-of-directors",
            },
            {
                iconSrc: "advisors.svg",
                name: "Advisors",
                text: "Experts in science, innovation, and digital health guiding our mission forward.",
                href: "/our-team#advisors",
            },
        ],
    },
    {
        navName: "Resources & News",
        title: "Resources & News",
        text: "Explore insights, tools, and updates from Keel Mind. Access downloadable resources, real-world use cases, and the latest stories shaping the future of digital mental health care.",
        hideOnDigital: true,
        children: [
            {
                iconSrc: "resource-centre.svg",
                name: "Resource centre",
                text: "A central hub of articles, videos, and tools designed to support mental health training, education, and self-care.",
                href: "/mind/resource-centre",
            },
            {
                iconSrc: "news-room.svg",
                name: "News room",
                text: "Stay up to date with the latest company announcements, partnerships, and advancements in digital mental health.",
                href: "/mind/news",
            },
        ],
    },
];
